/**
 * @file constants/account.js
 */

import { getString } from "config-api";

export const SUBSCRIPTION_CENTRE = getString("Client.membership.subCentre");

export const SIGN_IN_PATH = "/account/login";

export const FEATURES_PATH = "/account/features";

export const PRIVACY_PATH = "/account/privacy";

export const PROFILE_PATH = "/account/profile";
